import { EnvironmentProviders, Provider } from '@angular/core';
import { provideSoftAppsModule, withSoftAppsModuleTranslation } from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { getModuleGroupByName } from '@softline/application';

export const rohstoffbereitstellungProviders: Array<Provider | EnvironmentProviders> = [
  provideSoftAppsModule(
    {
      name: '#PRODUKTION_ROHSTOFFBEREITSTELLUNG.TITLE',
      title: '#PRODUKTION_ROHSTOFFBEREITSTELLUNG.TITLE',
      icon: 'fa-regular fa-industry-windows',
      route: '/rohstoffbereitstellung/start',
      group: getModuleGroupByName('Produktion'),
    },
    withSoftAppsModuleTranslation({
      de,
    })
  ),
];
